module.exports = __webpack_public_path__ + "static/img/8083_phase_function_Paper_Points.705054e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8083_phase_function_Paper_Points.png
// module id = m2I5
// module chunks = 0